import { Route } from '@angular/router';

import { ImpressumComponent } from '@metallgehalt/shared';
import { PrivacyPolicyComponent } from '@metallgehalt/shared';

import { OverviewComponent } from './labour-agreement-table/components/overview/overview.component';
import { TvoedSubTablesComponent } from './labour-agreement-table/components/tvoed-sub-tables/tvoed-sub-tables.component';
import { TvoedTableComponent } from './labour-agreement-table/components/tvoed-table/tvoed-table.component';
import { BlogComponent } from './blog/components/blog/blog.component';

export const appRoutes: Route[] = [
  {
    path: 'tariftabellen',
    children: [
      { path: '', redirectTo: 'übersicht', pathMatch: 'full' },
      { path: 'übersicht', component: OverviewComponent },
      { path: ':tarifänderung', component: TvoedSubTablesComponent },
      { path: ':tarifänderung/:bereich', component: TvoedTableComponent }
    ]
  },
  { path: 'blog', component: BlogComponent },
  { path: 'impressum', component: ImpressumComponent },
  { path: 'datenschutz', component: PrivacyPolicyComponent },
  { path: '**', redirectTo: 'gehalt', pathMatch: 'full' }
];
